import { defineComponent as b, onMounted as C, onUnmounted as B, ref as y, computed as h, openBlock as v, createBlock as m, unref as c, withCtx as i, createElementVNode as R, createVNode as d, renderSlot as k, createCommentVNode as x, Teleport as $, Transition as N, normalizeStyle as L, normalizeClass as T } from "vue";
import { Popover as V, PopoverButton as X, PopoverPanel as Y } from "./index274.js";
const r = 8, F = /* @__PURE__ */ b({
  __name: "BasePopover",
  props: {
    panelClass: { default: "" },
    position: { default: "bottom" }
  },
  setup(p) {
    const P = b({
      name: "BasePopoverScrollSync",
      props: {
        triggerRef: {
          type: Object,
          required: !0
        }
      },
      emits: ["scroll"],
      setup(a, { emit: e }) {
        const o = [], l = () => e("scroll");
        return C(() => {
          const s = a.triggerRef?.value?.value ?? null;
          if (!s) return;
          let n = s.parentElement;
          for (; n; ) {
            const { overflowX: u, overflowY: E } = getComputedStyle(n);
            (/(auto|scroll|overlay)/.test(u) || /(auto|scroll|overlay)/.test(E)) && o.push(n), n = n.parentElement;
          }
          o.push(window), o.forEach((u) => u.addEventListener("scroll", l, !0));
        }), B(() => {
          o.forEach((s) => s.removeEventListener("scroll", l, !0));
        }), () => null;
      }
    }), S = p, f = y(null), _ = h(() => ({ value: f })), t = y({ top: 0, left: 0, transform: "" }), g = () => {
      const a = f.value;
      if (!a) return;
      const e = a.getBoundingClientRect(), o = e.left + e.width / 2, l = e.top + e.height / 2;
      switch (S.position) {
        case "top":
          t.value = { top: e.top - r, left: o, transform: "translate(-50%, -100%)" };
          break;
        case "top-left":
          t.value = { top: e.top - r, left: e.left, transform: "translateY(-100%)" };
          break;
        case "top-right":
          t.value = { top: e.top - r, left: e.right, transform: "translate(-100%, -100%)" };
          break;
        case "left":
          t.value = { top: l, left: e.left - r, transform: "translate(-100%, -50%)" };
          break;
        case "right":
          t.value = { top: l, left: e.right + r, transform: "translateY(-50%)" };
          break;
        case "bottom-left":
          t.value = { top: e.bottom + r, left: e.left, transform: "" };
          break;
        case "bottom-right":
          t.value = { top: e.bottom + r, left: e.right, transform: "translateX(-100%)" };
          break;
        case "bottom":
        default:
          t.value = { top: e.bottom + r, left: o, transform: "translateX(-50%)" };
          break;
      }
    }, w = h(() => ({
      position: "fixed",
      top: `${t.value.top}px`,
      left: `${t.value.left}px`,
      transform: t.value.transform
    }));
    return (a, e) => (v(), m(c(V), { class: "base-popover relative" }, {
      default: i(({ open: o, close: l }) => [
        R("div", {
          ref_key: "triggerRef",
          ref: f,
          class: "inline-block",
          onPointerdown: g
        }, [
          d(c(X), null, {
            default: i(() => [
              k(a.$slots, "trigger", { open: o }, void 0, !0)
            ]),
            _: 2
          }, 1024)
        ], 544),
        o ? (v(), m(c(P), {
          key: 0,
          "trigger-ref": _.value,
          onScroll: g
        }, null, 8, ["trigger-ref"])) : x("", !0),
        (v(), m($, { to: "#overlay-root" }, [
          d(N, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "opacity-0 scale-95",
            "enter-to-class": "opacity-100 scale-100",
            "leave-active-class": "transition duration-150 ease-in",
            "leave-from-class": "opacity-100 scale-100",
            "leave-to-class": "opacity-0 scale-95"
          }, {
            default: i(() => [
              d(c(Y), {
                class: T(["base-popover__panel", p.panelClass, `base-popover__panel--${p.position}`]),
                style: L(w.value)
              }, {
                default: i(({ close: s }) => [
                  k(a.$slots, "content", {
                    open: o,
                    close: s
                  }, void 0, !0)
                ]),
                _: 2
              }, 1032, ["class", "style"])
            ]),
            _: 2
          }, 1024)
        ]))
      ]),
      _: 3
    }));
  }
});
export {
  F as default
};
